<template>
  <div class="block">
    <span
      v-if="!isShowPromoCode"
      class="addition-info-switcher unselectable"
      @click="isShowPromoCode = true"
    >
      Использовать промокод
    </span>
    <div
      class="string promocode"
     v-else
    >
      <div class="fields two">
        <div class="order-input">
          <input
            :disabled="isPromoDisabled"
            type="text"
            placeholder="Промокод"
            v-model="promocode"
            class="input-with-icon"
            :style="{ 'background-image': inputIcon }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PromocodeMixin from '@apps/order-form/src/mixins/promocode'

export default {
  name: 'Promocode',
  mixins: [PromocodeMixin],
  data() {
    return {
      isShowPromoCode: false,
    }
  }
}
</script>

<style lang="scss" scoped>
.block {
  margin-top: 16px;
}
</style>
